import { useFeatureFlag } from '@moda/portal-stanchions';

const DEFAULT_NUMBER_OF_PRODUCTS_PER_PAGE = 60;

export const useNumberOfProductsPerPage = () =>
  useFeatureFlag('products-per-page', [
    { default: DEFAULT_NUMBER_OF_PRODUCTS_PER_PAGE },
    { getFromTreatment: treatment => Number(treatment) || DEFAULT_NUMBER_OF_PRODUCTS_PER_PAGE }
  ]);
